// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectMenu_root__XN_Xb","body":"SelectMenu_body__sgKsO","header":"SelectMenu_header__HYhFn","close":"SelectMenu_close__oatHv"};